import { router } from 'expo-router';
import * as React from 'react';
import {
    CheckIcon,
    H5Emphasized,
    Icon,
    isWeb,
    Shadows,
    View,
    YStack,
} from 'smoothie';

import KycButton from './KycButton';

const Approved = () => {
    return (
        <YStack
            flex={1}
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
            gap={isWeb ? 60 : 16}
        >
            <View>
                <View
                    alignSelf="center"
                    padding={25}
                    borderRadius={20}
                    backgroundColor="$white"
                    marginTop={30}
                    marginBottom={30}
                    style={{ ...Shadows.MEDIUM }}
                >
                    <Icon icon={CheckIcon} size={30} color="$black" />
                </View>
                <H5Emphasized
                    textAlign="center"
                    marginBottom={14}
                    marginHorizontal={12}
                >
                    We&apos;ve verified your identity, let&apos;s{'\n'} open
                    your account!
                </H5Emphasized>
            </View>
            <KycButton
                onPress={() => {
                    router.navigate({
                        pathname: '/banking/onboarding/space-ownership',
                        params: {
                            fromKyc: 'true',
                        },
                    });
                }}
                text="Finish opening account"
                hideSecureText
            />
        </YStack>
    );
};

export default Approved;
